/*------------------------------------*\
    NAV DROPDOWN
\*------------------------------------*/
class NavDropdown {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('[data-nav-dropdown-trigger]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            evt.preventDefault();

            if (self.elem.classList.contains('is-open')) {
                // If the dropdown is open, close it
                self.closeDropdown();
            } else {
                // Else open it
                self.openDropdown();
            }
        });
    }

    openDropdown() {
        let self = this;

        self.elem.classList.add('is-open');

        self.addEventListeners();
    }

    closeDropdown() {
        let self = this;

        self.elem.classList.remove('is-open');

        self.removeEventListeners();
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown/trigger
        document.addEventListener('click', self.onOutsideClick);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown/trigger
        document.removeEventListener('click', self.onOutsideClick);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on:
        // a) this dropdown
        // b) a child element of this dropdown
        if (evt.target !== self.elem && evt.target.closest('[data-module="nav-dropdown"]') !== self.elem) {
            // Close all menus
            self.closeDropdown();
        }
    }
}

export default NavDropdown;
